import { useQuery } from "@tanstack/react-query";
import * as AgenticV2API from "@/services/api/agentic-v2";
import type { AgentSummary } from "../types";
import { useWindowLive } from "@/components/ui/os-layout/WindowActiveContext";

const agentsKey = ["agentic-v2", "agents"] as const;

export interface UseAgentsQueryOptions {
  enabled?: boolean;
}

/** Cached company agent directory (for mission assignee resolution in lists). */
export function useAgentsQuery({ enabled: enabledOption = true }: UseAgentsQueryOptions = {}) {
  const isWindowLive = useWindowLive();
  const queryEnabled = enabledOption && isWindowLive;

  const query = useQuery<AgentSummary[]>({
    queryKey: agentsKey,
    enabled: queryEnabled,
    staleTime: 5 * 60_000,
    queryFn: () => AgenticV2API.listAgents(),
  });

  return query.data ?? [];
}
